module.exports = __webpack_public_path__ + "img/Enercoop_80X30.37f16708.png";